// extracted by mini-css-extract-plugin
export default {"tag":"SharedByGroupMemberTag_tag__+oQRs","status":"SharedByGroupMemberTag_status__FdL-w"};